import { render, staticRenderFns } from "./ai-tizhi.vue?vue&type=template&id=10e0eded&scoped=true"
import script from "./ai-tizhi.vue?vue&type=script&lang=ts"
export * from "./ai-tizhi.vue?vue&type=script&lang=ts"
import style0 from "./ai-tizhi.vue?vue&type=style&index=0&id=10e0eded&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10e0eded",
  null
  
)

export default component.exports